/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as Char91__e2eChar93ExternalDisplayRouteImport } from './routes/[__e2e]/external-display'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as AuthenticatedAlertsRouteImport } from './routes/_authenticated/alerts'
import { Route as AuthenticatedChecksheetDataRouteImport } from './routes/_authenticated/checksheet-data'
import { Route as AuthenticatedChecksheetsRouteImport } from './routes/_authenticated/checksheets'
import { Route as AuthenticatedClockingRecsRouteImport } from './routes/_authenticated/clockingRecs'
import { Route as AuthenticatedConfigurationRouteImport } from './routes/_authenticated/configuration'
import { Route as AuthenticatedConnectorsRouteImport } from './routes/_authenticated/connectors'
import { Route as AuthenticatedCustomerHealthRouteImport } from './routes/_authenticated/customerHealth'
import { Route as AuthenticatedDashboardRouteRouteImport } from './routes/_authenticated/dashboard/route'
import { Route as AuthenticatedDeviceGroupsRouteImport } from './routes/_authenticated/deviceGroups'
import { Route as AuthenticatedDevicesRouteImport } from './routes/_authenticated/devices'
import { Route as AuthenticatedDevicesAdminRouteImport } from './routes/_authenticated/devicesAdmin'
import { Route as AuthenticatedDocumentManagerRouteImport } from './routes/_authenticated/documentManager'
import { Route as AuthenticatedEmployeeGroupsRouteImport } from './routes/_authenticated/employeeGroups'
import { Route as AuthenticatedEmployeesRouteImport } from './routes/_authenticated/employees'
import { Route as AuthenticatedEntitiesRouteImport } from './routes/_authenticated/entities'
import { Route as AuthenticatedEntityAdminRouteImport } from './routes/_authenticated/entityAdmin'
import { Route as AuthenticatedEntitySetupRouteImport } from './routes/_authenticated/entitySetup'
import { Route as AuthenticatedExternalDisplayLayoutsRouteImport } from './routes/_authenticated/externalDisplayLayouts'
import { Route as AuthenticatedFlowsRouteImport } from './routes/_authenticated/flows'
import { Route as AuthenticatedFulfillmentAdminRouteImport } from './routes/_authenticated/fulfillmentAdmin'
import { Route as AuthenticatedFunctionalTestingRouteImport } from './routes/_authenticated/functionalTesting'
import { Route as AuthenticatedGuidedSetupsRouteImport } from './routes/_authenticated/guidedSetups'
import { Route as AuthenticatedIndirectsRouteImport } from './routes/_authenticated/indirects'
import { Route as AuthenticatedInstructionsRouteImport } from './routes/_authenticated/instructions'
import { Route as AuthenticatedJobsRouteImport } from './routes/_authenticated/jobs'
import { Route as AuthenticatedLaborOutcomePredictionRouteImport } from './routes/_authenticated/laborOutcomePrediction'
import { Route as AuthenticatedLaborRecsRouteImport } from './routes/_authenticated/laborRecs'
import { Route as AuthenticatedLocationAdminRouteImport } from './routes/_authenticated/locationAdmin'
import { Route as AuthenticatedLocationManagementRouteImport } from './routes/_authenticated/locationManagement'
import { Route as AuthenticatedMachineReasonCategoriesRouteImport } from './routes/_authenticated/machineReasonCategories'
import { Route as AuthenticatedMachineReasonsRouteImport } from './routes/_authenticated/machineReasons'
import { Route as AuthenticatedMachineRecsRouteImport } from './routes/_authenticated/machineRecs'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedOptionsRegistryRouteImport } from './routes/_authenticated/optionsRegistry'
import { Route as AuthenticatedOrganizationAdminRouteImport } from './routes/_authenticated/organizationAdmin'
import { Route as AuthenticatedOrganizationsRouteImport } from './routes/_authenticated/organizations'
import { Route as AuthenticatedPartsRouteImport } from './routes/_authenticated/parts'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedProgramsRouteImport } from './routes/_authenticated/programs'
import { Route as AuthenticatedReasonsRouteImport } from './routes/_authenticated/reasons'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedRequestTypesRouteImport } from './routes/_authenticated/requestTypes'
import { Route as AuthenticatedResourceAdminRouteImport } from './routes/_authenticated/resourceAdmin'
import { Route as AuthenticatedResourcesRouteImport } from './routes/_authenticated/resources'
import { Route as AuthenticatedRuleSetsRouteImport } from './routes/_authenticated/ruleSets'
import { Route as AuthenticatedScheduledTasksRouteImport } from './routes/_authenticated/scheduledTasks'
import { Route as AuthenticatedSchedulesRouteImport } from './routes/_authenticated/schedules'
import { Route as AuthenticatedScopeFiltersRouteImport } from './routes/_authenticated/scopeFilters'
import { Route as AuthenticatedSecurityRouteImport } from './routes/_authenticated/security'
import { Route as AuthenticatedShiftsRouteImport } from './routes/_authenticated/shifts'
import { Route as AuthenticatedTagAssociationTypesRouteImport } from './routes/_authenticated/tagAssociationTypes'
import { Route as AuthenticatedTagsRouteImport } from './routes/_authenticated/tags'
import { Route as AuthenticatedTimesheetsRouteRouteImport } from './routes/_authenticated/timesheets/route'
import { Route as AuthenticatedTrainingAdminRouteImport } from './routes/_authenticated/trainingAdmin'
import { Route as AuthenticatedWorkQueueRouteImport } from './routes/_authenticated/workQueue'
import { Route as DisplayIndexRouteImport } from './routes/display/index'
import { Route as DisplayDeviceIdRouteImport } from './routes/display/$deviceId'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginCreatePasswordRouteImport } from './routes/login/createPassword'
import { Route as LoginForgotPasswordRouteImport } from './routes/login/forgotPassword'
import { Route as LoginResetPasswordRouteImport } from './routes/login/resetPassword'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardActivityRouteRouteImport } from './routes/_authenticated/dashboard/activity/route'
import { Route as AuthenticatedDashboardEfficiencyRouteRouteImport } from './routes/_authenticated/dashboard/efficiency/route'
import { Route as AuthenticatedDashboardLocatingRouteRouteImport } from './routes/_authenticated/dashboard/locating/route'
import { Route as AuthenticatedDashboardQualityRouteRouteImport } from './routes/_authenticated/dashboard/quality/route'
import { Route as AuthenticatedDashboardRoiRouteRouteImport } from './routes/_authenticated/dashboard/roi/route'
import { Route as AuthenticatedGuidedSetupsSplatRouteImport } from './routes/_authenticated/guidedSetups.$'
import { Route as AuthenticatedRequestsChar123RequestIdChar125RouteImport } from './routes/_authenticated/requests.{-$requestId}'
import { Route as AuthenticatedTimesheetsIndexRouteImport } from './routes/_authenticated/timesheets/index'
import { Route as AuthenticatedDashboardActivityIndexRouteImport } from './routes/_authenticated/dashboard/activity/index'
import { Route as AuthenticatedDashboardActivityCanvasIdRouteImport } from './routes/_authenticated/dashboard/activity/$canvasId'
import { Route as AuthenticatedDashboardEfficiencyIndexRouteImport } from './routes/_authenticated/dashboard/efficiency/index'
import { Route as AuthenticatedDashboardEfficiencyCanvasIdRouteImport } from './routes/_authenticated/dashboard/efficiency/$canvasId'
import { Route as AuthenticatedDashboardLocatingIndexRouteImport } from './routes/_authenticated/dashboard/locating/index'
import { Route as AuthenticatedDashboardLocatingCanvasIdRouteImport } from './routes/_authenticated/dashboard/locating/$canvasId'
import { Route as AuthenticatedDashboardQualityIndexRouteImport } from './routes/_authenticated/dashboard/quality/index'
import { Route as AuthenticatedDashboardQualityCanvasIdRouteImport } from './routes/_authenticated/dashboard/quality/$canvasId'
import { Route as AuthenticatedDashboardRoiIndexRouteImport } from './routes/_authenticated/dashboard/roi/index'
import { Route as AuthenticatedDashboardRoiCanvasIdRouteImport } from './routes/_authenticated/dashboard/roi/$canvasId'
import { Route as AuthenticatedTimesheetsEmployeesEmpIdRouteImport } from './routes/_authenticated/timesheets/employees/$empId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const Char91__e2eChar93ExternalDisplayRoute =
  Char91__e2eChar93ExternalDisplayRouteImport.update({
    id: '/__e2e/external-display',
    path: '/__e2e/external-display',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAlertsRoute = AuthenticatedAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChecksheetDataRoute =
  AuthenticatedChecksheetDataRouteImport.update({
    id: '/checksheet-data',
    path: '/checksheet-data',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChecksheetsRoute =
  AuthenticatedChecksheetsRouteImport.update({
    id: '/checksheets',
    path: '/checksheets',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClockingRecsRoute =
  AuthenticatedClockingRecsRouteImport.update({
    id: '/clockingRecs',
    path: '/clockingRecs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConfigurationRoute =
  AuthenticatedConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConnectorsRoute = AuthenticatedConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCustomerHealthRoute =
  AuthenticatedCustomerHealthRouteImport.update({
    id: '/customerHealth',
    path: '/customerHealth',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRouteRoute =
  AuthenticatedDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDeviceGroupsRoute =
  AuthenticatedDeviceGroupsRouteImport.update({
    id: '/deviceGroups',
    path: '/deviceGroups',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesRoute = AuthenticatedDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDevicesAdminRoute =
  AuthenticatedDevicesAdminRouteImport.update({
    id: '/devicesAdmin',
    path: '/devicesAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentManagerRoute =
  AuthenticatedDocumentManagerRouteImport.update({
    id: '/documentManager',
    path: '/documentManager',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmployeeGroupsRoute =
  AuthenticatedEmployeeGroupsRouteImport.update({
    id: '/employeeGroups',
    path: '/employeeGroups',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmployeesRoute = AuthenticatedEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedEntitiesRoute = AuthenticatedEntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedEntityAdminRoute =
  AuthenticatedEntityAdminRouteImport.update({
    id: '/entityAdmin',
    path: '/entityAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEntitySetupRoute =
  AuthenticatedEntitySetupRouteImport.update({
    id: '/entitySetup',
    path: '/entitySetup',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExternalDisplayLayoutsRoute =
  AuthenticatedExternalDisplayLayoutsRouteImport.update({
    id: '/externalDisplayLayouts',
    path: '/externalDisplayLayouts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFlowsRoute = AuthenticatedFlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFulfillmentAdminRoute =
  AuthenticatedFulfillmentAdminRouteImport.update({
    id: '/fulfillmentAdmin',
    path: '/fulfillmentAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFunctionalTestingRoute =
  AuthenticatedFunctionalTestingRouteImport.update({
    id: '/functionalTesting',
    path: '/functionalTesting',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGuidedSetupsRoute =
  AuthenticatedGuidedSetupsRouteImport.update({
    id: '/guidedSetups',
    path: '/guidedSetups',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIndirectsRoute = AuthenticatedIndirectsRouteImport.update({
  id: '/indirects',
  path: '/indirects',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInstructionsRoute =
  AuthenticatedInstructionsRouteImport.update({
    id: '/instructions',
    path: '/instructions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsRoute = AuthenticatedJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLaborOutcomePredictionRoute =
  AuthenticatedLaborOutcomePredictionRouteImport.update({
    id: '/laborOutcomePrediction',
    path: '/laborOutcomePrediction',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLaborRecsRoute = AuthenticatedLaborRecsRouteImport.update({
  id: '/laborRecs',
  path: '/laborRecs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLocationAdminRoute =
  AuthenticatedLocationAdminRouteImport.update({
    id: '/locationAdmin',
    path: '/locationAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLocationManagementRoute =
  AuthenticatedLocationManagementRouteImport.update({
    id: '/locationManagement',
    path: '/locationManagement',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMachineReasonCategoriesRoute =
  AuthenticatedMachineReasonCategoriesRouteImport.update({
    id: '/machineReasonCategories',
    path: '/machineReasonCategories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMachineReasonsRoute =
  AuthenticatedMachineReasonsRouteImport.update({
    id: '/machineReasons',
    path: '/machineReasons',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMachineRecsRoute =
  AuthenticatedMachineRecsRouteImport.update({
    id: '/machineRecs',
    path: '/machineRecs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOptionsRegistryRoute =
  AuthenticatedOptionsRegistryRouteImport.update({
    id: '/optionsRegistry',
    path: '/optionsRegistry',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationAdminRoute =
  AuthenticatedOrganizationAdminRouteImport.update({
    id: '/organizationAdmin',
    path: '/organizationAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationsRoute =
  AuthenticatedOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsRoute = AuthenticatedPartsRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProgramsRoute = AuthenticatedProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedReasonsRoute = AuthenticatedReasonsRouteImport.update({
  id: '/reasons',
  path: '/reasons',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRequestTypesRoute =
  AuthenticatedRequestTypesRouteImport.update({
    id: '/requestTypes',
    path: '/requestTypes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResourceAdminRoute =
  AuthenticatedResourceAdminRouteImport.update({
    id: '/resourceAdmin',
    path: '/resourceAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResourcesRoute = AuthenticatedResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRuleSetsRoute = AuthenticatedRuleSetsRouteImport.update({
  id: '/ruleSets',
  path: '/ruleSets',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedScheduledTasksRoute =
  AuthenticatedScheduledTasksRouteImport.update({
    id: '/scheduledTasks',
    path: '/scheduledTasks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSchedulesRoute = AuthenticatedSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedScopeFiltersRoute =
  AuthenticatedScopeFiltersRouteImport.update({
    id: '/scopeFilters',
    path: '/scopeFilters',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSecurityRoute = AuthenticatedSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedShiftsRoute = AuthenticatedShiftsRouteImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTagAssociationTypesRoute =
  AuthenticatedTagAssociationTypesRouteImport.update({
    id: '/tagAssociationTypes',
    path: '/tagAssociationTypes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTagsRoute = AuthenticatedTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTimesheetsRouteRoute =
  AuthenticatedTimesheetsRouteRouteImport.update({
    id: '/timesheets',
    path: '/timesheets',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTrainingAdminRoute =
  AuthenticatedTrainingAdminRouteImport.update({
    id: '/trainingAdmin',
    path: '/trainingAdmin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkQueueRoute = AuthenticatedWorkQueueRouteImport.update({
  id: '/workQueue',
  path: '/workQueue',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const DisplayIndexRoute = DisplayIndexRouteImport.update({
  id: '/display/',
  path: '/display/',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayDeviceIdRoute = DisplayDeviceIdRouteImport.update({
  id: '/display/$deviceId',
  path: '/display/$deviceId',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginCreatePasswordRoute = LoginCreatePasswordRouteImport.update({
  id: '/createPassword',
  path: '/createPassword',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginForgotPasswordRoute = LoginForgotPasswordRouteImport.update({
  id: '/forgotPassword',
  path: '/forgotPassword',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginResetPasswordRoute = LoginResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => LoginRouteRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardActivityRouteRoute =
  AuthenticatedDashboardActivityRouteRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardEfficiencyRouteRoute =
  AuthenticatedDashboardEfficiencyRouteRouteImport.update({
    id: '/efficiency',
    path: '/efficiency',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardLocatingRouteRoute =
  AuthenticatedDashboardLocatingRouteRouteImport.update({
    id: '/locating',
    path: '/locating',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardQualityRouteRoute =
  AuthenticatedDashboardQualityRouteRouteImport.update({
    id: '/quality',
    path: '/quality',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardRoiRouteRoute =
  AuthenticatedDashboardRoiRouteRouteImport.update({
    id: '/roi',
    path: '/roi',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedGuidedSetupsSplatRoute =
  AuthenticatedGuidedSetupsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedGuidedSetupsRoute,
  } as any)
const AuthenticatedRequestsChar123RequestIdChar125Route =
  AuthenticatedRequestsChar123RequestIdChar125RouteImport.update({
    id: '/requests/{-$requestId}',
    path: '/requests/{-$requestId}',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTimesheetsIndexRoute =
  AuthenticatedTimesheetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTimesheetsRouteRoute,
  } as any)
const AuthenticatedDashboardActivityIndexRoute =
  AuthenticatedDashboardActivityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardActivityRouteRoute,
  } as any)
const AuthenticatedDashboardActivityCanvasIdRoute =
  AuthenticatedDashboardActivityCanvasIdRouteImport.update({
    id: '/$canvasId',
    path: '/$canvasId',
    getParentRoute: () => AuthenticatedDashboardActivityRouteRoute,
  } as any)
const AuthenticatedDashboardEfficiencyIndexRoute =
  AuthenticatedDashboardEfficiencyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardEfficiencyRouteRoute,
  } as any)
const AuthenticatedDashboardEfficiencyCanvasIdRoute =
  AuthenticatedDashboardEfficiencyCanvasIdRouteImport.update({
    id: '/$canvasId',
    path: '/$canvasId',
    getParentRoute: () => AuthenticatedDashboardEfficiencyRouteRoute,
  } as any)
const AuthenticatedDashboardLocatingIndexRoute =
  AuthenticatedDashboardLocatingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardLocatingRouteRoute,
  } as any)
const AuthenticatedDashboardLocatingCanvasIdRoute =
  AuthenticatedDashboardLocatingCanvasIdRouteImport.update({
    id: '/$canvasId',
    path: '/$canvasId',
    getParentRoute: () => AuthenticatedDashboardLocatingRouteRoute,
  } as any)
const AuthenticatedDashboardQualityIndexRoute =
  AuthenticatedDashboardQualityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardQualityRouteRoute,
  } as any)
const AuthenticatedDashboardQualityCanvasIdRoute =
  AuthenticatedDashboardQualityCanvasIdRouteImport.update({
    id: '/$canvasId',
    path: '/$canvasId',
    getParentRoute: () => AuthenticatedDashboardQualityRouteRoute,
  } as any)
const AuthenticatedDashboardRoiIndexRoute =
  AuthenticatedDashboardRoiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRoiRouteRoute,
  } as any)
const AuthenticatedDashboardRoiCanvasIdRoute =
  AuthenticatedDashboardRoiCanvasIdRouteImport.update({
    id: '/$canvasId',
    path: '/$canvasId',
    getParentRoute: () => AuthenticatedDashboardRoiRouteRoute,
  } as any)
const AuthenticatedTimesheetsEmployeesEmpIdRoute =
  AuthenticatedTimesheetsEmployeesEmpIdRouteImport.update({
    id: '/employees/$empId',
    path: '/employees/$empId',
    getParentRoute: () => AuthenticatedTimesheetsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRouteRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/timesheets': typeof AuthenticatedTimesheetsRouteRouteWithChildren
  '/__e2e/external-display': typeof Char91__e2eChar93ExternalDisplayRoute
  '/$': typeof AuthenticatedSplatRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/checksheet-data': typeof AuthenticatedChecksheetDataRoute
  '/checksheets': typeof AuthenticatedChecksheetsRoute
  '/clockingRecs': typeof AuthenticatedClockingRecsRoute
  '/configuration': typeof AuthenticatedConfigurationRoute
  '/connectors': typeof AuthenticatedConnectorsRoute
  '/customerHealth': typeof AuthenticatedCustomerHealthRoute
  '/deviceGroups': typeof AuthenticatedDeviceGroupsRoute
  '/devices': typeof AuthenticatedDevicesRoute
  '/devicesAdmin': typeof AuthenticatedDevicesAdminRoute
  '/documentManager': typeof AuthenticatedDocumentManagerRoute
  '/employeeGroups': typeof AuthenticatedEmployeeGroupsRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/entities': typeof AuthenticatedEntitiesRoute
  '/entityAdmin': typeof AuthenticatedEntityAdminRoute
  '/entitySetup': typeof AuthenticatedEntitySetupRoute
  '/externalDisplayLayouts': typeof AuthenticatedExternalDisplayLayoutsRoute
  '/flows': typeof AuthenticatedFlowsRoute
  '/fulfillmentAdmin': typeof AuthenticatedFulfillmentAdminRoute
  '/functionalTesting': typeof AuthenticatedFunctionalTestingRoute
  '/guidedSetups': typeof AuthenticatedGuidedSetupsRouteWithChildren
  '/indirects': typeof AuthenticatedIndirectsRoute
  '/instructions': typeof AuthenticatedInstructionsRoute
  '/jobs': typeof AuthenticatedJobsRoute
  '/laborOutcomePrediction': typeof AuthenticatedLaborOutcomePredictionRoute
  '/laborRecs': typeof AuthenticatedLaborRecsRoute
  '/locationAdmin': typeof AuthenticatedLocationAdminRoute
  '/locationManagement': typeof AuthenticatedLocationManagementRoute
  '/machineReasonCategories': typeof AuthenticatedMachineReasonCategoriesRoute
  '/machineReasons': typeof AuthenticatedMachineReasonsRoute
  '/machineRecs': typeof AuthenticatedMachineRecsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/optionsRegistry': typeof AuthenticatedOptionsRegistryRoute
  '/organizationAdmin': typeof AuthenticatedOrganizationAdminRoute
  '/organizations': typeof AuthenticatedOrganizationsRoute
  '/parts': typeof AuthenticatedPartsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/programs': typeof AuthenticatedProgramsRoute
  '/reasons': typeof AuthenticatedReasonsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/requestTypes': typeof AuthenticatedRequestTypesRoute
  '/resourceAdmin': typeof AuthenticatedResourceAdminRoute
  '/resources': typeof AuthenticatedResourcesRoute
  '/ruleSets': typeof AuthenticatedRuleSetsRoute
  '/scheduledTasks': typeof AuthenticatedScheduledTasksRoute
  '/schedules': typeof AuthenticatedSchedulesRoute
  '/scopeFilters': typeof AuthenticatedScopeFiltersRoute
  '/security': typeof AuthenticatedSecurityRoute
  '/shifts': typeof AuthenticatedShiftsRoute
  '/tagAssociationTypes': typeof AuthenticatedTagAssociationTypesRoute
  '/tags': typeof AuthenticatedTagsRoute
  '/trainingAdmin': typeof AuthenticatedTrainingAdminRoute
  '/workQueue': typeof AuthenticatedWorkQueueRoute
  '/display/$deviceId': typeof DisplayDeviceIdRoute
  '/login/createPassword': typeof LoginCreatePasswordRoute
  '/login/forgotPassword': typeof LoginForgotPasswordRoute
  '/login/resetPassword': typeof LoginResetPasswordRoute
  '/display/': typeof DisplayIndexRoute
  '/login/': typeof LoginIndexRoute
  '/dashboard/activity': typeof AuthenticatedDashboardActivityRouteRouteWithChildren
  '/dashboard/efficiency': typeof AuthenticatedDashboardEfficiencyRouteRouteWithChildren
  '/dashboard/locating': typeof AuthenticatedDashboardLocatingRouteRouteWithChildren
  '/dashboard/quality': typeof AuthenticatedDashboardQualityRouteRouteWithChildren
  '/dashboard/roi': typeof AuthenticatedDashboardRoiRouteRouteWithChildren
  '/guidedSetups/$': typeof AuthenticatedGuidedSetupsSplatRoute
  '/requests/{-$requestId}': typeof AuthenticatedRequestsChar123RequestIdChar125Route
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/timesheets/': typeof AuthenticatedTimesheetsIndexRoute
  '/dashboard/activity/$canvasId': typeof AuthenticatedDashboardActivityCanvasIdRoute
  '/dashboard/efficiency/$canvasId': typeof AuthenticatedDashboardEfficiencyCanvasIdRoute
  '/dashboard/locating/$canvasId': typeof AuthenticatedDashboardLocatingCanvasIdRoute
  '/dashboard/quality/$canvasId': typeof AuthenticatedDashboardQualityCanvasIdRoute
  '/dashboard/roi/$canvasId': typeof AuthenticatedDashboardRoiCanvasIdRoute
  '/timesheets/employees/$empId': typeof AuthenticatedTimesheetsEmployeesEmpIdRoute
  '/dashboard/activity/': typeof AuthenticatedDashboardActivityIndexRoute
  '/dashboard/efficiency/': typeof AuthenticatedDashboardEfficiencyIndexRoute
  '/dashboard/locating/': typeof AuthenticatedDashboardLocatingIndexRoute
  '/dashboard/quality/': typeof AuthenticatedDashboardQualityIndexRoute
  '/dashboard/roi/': typeof AuthenticatedDashboardRoiIndexRoute
}
export interface FileRoutesByTo {
  '/__e2e/external-display': typeof Char91__e2eChar93ExternalDisplayRoute
  '/$': typeof AuthenticatedSplatRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/checksheet-data': typeof AuthenticatedChecksheetDataRoute
  '/checksheets': typeof AuthenticatedChecksheetsRoute
  '/clockingRecs': typeof AuthenticatedClockingRecsRoute
  '/configuration': typeof AuthenticatedConfigurationRoute
  '/connectors': typeof AuthenticatedConnectorsRoute
  '/customerHealth': typeof AuthenticatedCustomerHealthRoute
  '/deviceGroups': typeof AuthenticatedDeviceGroupsRoute
  '/devices': typeof AuthenticatedDevicesRoute
  '/devicesAdmin': typeof AuthenticatedDevicesAdminRoute
  '/documentManager': typeof AuthenticatedDocumentManagerRoute
  '/employeeGroups': typeof AuthenticatedEmployeeGroupsRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/entities': typeof AuthenticatedEntitiesRoute
  '/entityAdmin': typeof AuthenticatedEntityAdminRoute
  '/entitySetup': typeof AuthenticatedEntitySetupRoute
  '/externalDisplayLayouts': typeof AuthenticatedExternalDisplayLayoutsRoute
  '/flows': typeof AuthenticatedFlowsRoute
  '/fulfillmentAdmin': typeof AuthenticatedFulfillmentAdminRoute
  '/functionalTesting': typeof AuthenticatedFunctionalTestingRoute
  '/guidedSetups': typeof AuthenticatedGuidedSetupsRouteWithChildren
  '/indirects': typeof AuthenticatedIndirectsRoute
  '/instructions': typeof AuthenticatedInstructionsRoute
  '/jobs': typeof AuthenticatedJobsRoute
  '/laborOutcomePrediction': typeof AuthenticatedLaborOutcomePredictionRoute
  '/laborRecs': typeof AuthenticatedLaborRecsRoute
  '/locationAdmin': typeof AuthenticatedLocationAdminRoute
  '/locationManagement': typeof AuthenticatedLocationManagementRoute
  '/machineReasonCategories': typeof AuthenticatedMachineReasonCategoriesRoute
  '/machineReasons': typeof AuthenticatedMachineReasonsRoute
  '/machineRecs': typeof AuthenticatedMachineRecsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/optionsRegistry': typeof AuthenticatedOptionsRegistryRoute
  '/organizationAdmin': typeof AuthenticatedOrganizationAdminRoute
  '/organizations': typeof AuthenticatedOrganizationsRoute
  '/parts': typeof AuthenticatedPartsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/programs': typeof AuthenticatedProgramsRoute
  '/reasons': typeof AuthenticatedReasonsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/requestTypes': typeof AuthenticatedRequestTypesRoute
  '/resourceAdmin': typeof AuthenticatedResourceAdminRoute
  '/resources': typeof AuthenticatedResourcesRoute
  '/ruleSets': typeof AuthenticatedRuleSetsRoute
  '/scheduledTasks': typeof AuthenticatedScheduledTasksRoute
  '/schedules': typeof AuthenticatedSchedulesRoute
  '/scopeFilters': typeof AuthenticatedScopeFiltersRoute
  '/security': typeof AuthenticatedSecurityRoute
  '/shifts': typeof AuthenticatedShiftsRoute
  '/tagAssociationTypes': typeof AuthenticatedTagAssociationTypesRoute
  '/tags': typeof AuthenticatedTagsRoute
  '/trainingAdmin': typeof AuthenticatedTrainingAdminRoute
  '/workQueue': typeof AuthenticatedWorkQueueRoute
  '/display/$deviceId': typeof DisplayDeviceIdRoute
  '/login/createPassword': typeof LoginCreatePasswordRoute
  '/login/forgotPassword': typeof LoginForgotPasswordRoute
  '/login/resetPassword': typeof LoginResetPasswordRoute
  '/': typeof AuthenticatedIndexRoute
  '/display': typeof DisplayIndexRoute
  '/login': typeof LoginIndexRoute
  '/guidedSetups/$': typeof AuthenticatedGuidedSetupsSplatRoute
  '/requests/{-$requestId}': typeof AuthenticatedRequestsChar123RequestIdChar125Route
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/timesheets': typeof AuthenticatedTimesheetsIndexRoute
  '/dashboard/activity/$canvasId': typeof AuthenticatedDashboardActivityCanvasIdRoute
  '/dashboard/efficiency/$canvasId': typeof AuthenticatedDashboardEfficiencyCanvasIdRoute
  '/dashboard/locating/$canvasId': typeof AuthenticatedDashboardLocatingCanvasIdRoute
  '/dashboard/quality/$canvasId': typeof AuthenticatedDashboardQualityCanvasIdRoute
  '/dashboard/roi/$canvasId': typeof AuthenticatedDashboardRoiCanvasIdRoute
  '/timesheets/employees/$empId': typeof AuthenticatedTimesheetsEmployeesEmpIdRoute
  '/dashboard/activity': typeof AuthenticatedDashboardActivityIndexRoute
  '/dashboard/efficiency': typeof AuthenticatedDashboardEfficiencyIndexRoute
  '/dashboard/locating': typeof AuthenticatedDashboardLocatingIndexRoute
  '/dashboard/quality': typeof AuthenticatedDashboardQualityIndexRoute
  '/dashboard/roi': typeof AuthenticatedDashboardRoiIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/_authenticated/timesheets': typeof AuthenticatedTimesheetsRouteRouteWithChildren
  '/__e2e/external-display': typeof Char91__e2eChar93ExternalDisplayRoute
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/alerts': typeof AuthenticatedAlertsRoute
  '/_authenticated/checksheet-data': typeof AuthenticatedChecksheetDataRoute
  '/_authenticated/checksheets': typeof AuthenticatedChecksheetsRoute
  '/_authenticated/clockingRecs': typeof AuthenticatedClockingRecsRoute
  '/_authenticated/configuration': typeof AuthenticatedConfigurationRoute
  '/_authenticated/connectors': typeof AuthenticatedConnectorsRoute
  '/_authenticated/customerHealth': typeof AuthenticatedCustomerHealthRoute
  '/_authenticated/deviceGroups': typeof AuthenticatedDeviceGroupsRoute
  '/_authenticated/devices': typeof AuthenticatedDevicesRoute
  '/_authenticated/devicesAdmin': typeof AuthenticatedDevicesAdminRoute
  '/_authenticated/documentManager': typeof AuthenticatedDocumentManagerRoute
  '/_authenticated/employeeGroups': typeof AuthenticatedEmployeeGroupsRoute
  '/_authenticated/employees': typeof AuthenticatedEmployeesRoute
  '/_authenticated/entities': typeof AuthenticatedEntitiesRoute
  '/_authenticated/entityAdmin': typeof AuthenticatedEntityAdminRoute
  '/_authenticated/entitySetup': typeof AuthenticatedEntitySetupRoute
  '/_authenticated/externalDisplayLayouts': typeof AuthenticatedExternalDisplayLayoutsRoute
  '/_authenticated/flows': typeof AuthenticatedFlowsRoute
  '/_authenticated/fulfillmentAdmin': typeof AuthenticatedFulfillmentAdminRoute
  '/_authenticated/functionalTesting': typeof AuthenticatedFunctionalTestingRoute
  '/_authenticated/guidedSetups': typeof AuthenticatedGuidedSetupsRouteWithChildren
  '/_authenticated/indirects': typeof AuthenticatedIndirectsRoute
  '/_authenticated/instructions': typeof AuthenticatedInstructionsRoute
  '/_authenticated/jobs': typeof AuthenticatedJobsRoute
  '/_authenticated/laborOutcomePrediction': typeof AuthenticatedLaborOutcomePredictionRoute
  '/_authenticated/laborRecs': typeof AuthenticatedLaborRecsRoute
  '/_authenticated/locationAdmin': typeof AuthenticatedLocationAdminRoute
  '/_authenticated/locationManagement': typeof AuthenticatedLocationManagementRoute
  '/_authenticated/machineReasonCategories': typeof AuthenticatedMachineReasonCategoriesRoute
  '/_authenticated/machineReasons': typeof AuthenticatedMachineReasonsRoute
  '/_authenticated/machineRecs': typeof AuthenticatedMachineRecsRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/optionsRegistry': typeof AuthenticatedOptionsRegistryRoute
  '/_authenticated/organizationAdmin': typeof AuthenticatedOrganizationAdminRoute
  '/_authenticated/organizations': typeof AuthenticatedOrganizationsRoute
  '/_authenticated/parts': typeof AuthenticatedPartsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/programs': typeof AuthenticatedProgramsRoute
  '/_authenticated/reasons': typeof AuthenticatedReasonsRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/requestTypes': typeof AuthenticatedRequestTypesRoute
  '/_authenticated/resourceAdmin': typeof AuthenticatedResourceAdminRoute
  '/_authenticated/resources': typeof AuthenticatedResourcesRoute
  '/_authenticated/ruleSets': typeof AuthenticatedRuleSetsRoute
  '/_authenticated/scheduledTasks': typeof AuthenticatedScheduledTasksRoute
  '/_authenticated/schedules': typeof AuthenticatedSchedulesRoute
  '/_authenticated/scopeFilters': typeof AuthenticatedScopeFiltersRoute
  '/_authenticated/security': typeof AuthenticatedSecurityRoute
  '/_authenticated/shifts': typeof AuthenticatedShiftsRoute
  '/_authenticated/tagAssociationTypes': typeof AuthenticatedTagAssociationTypesRoute
  '/_authenticated/tags': typeof AuthenticatedTagsRoute
  '/_authenticated/trainingAdmin': typeof AuthenticatedTrainingAdminRoute
  '/_authenticated/workQueue': typeof AuthenticatedWorkQueueRoute
  '/display/$deviceId': typeof DisplayDeviceIdRoute
  '/login/createPassword': typeof LoginCreatePasswordRoute
  '/login/forgotPassword': typeof LoginForgotPasswordRoute
  '/login/resetPassword': typeof LoginResetPasswordRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/display/': typeof DisplayIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/dashboard/activity': typeof AuthenticatedDashboardActivityRouteRouteWithChildren
  '/_authenticated/dashboard/efficiency': typeof AuthenticatedDashboardEfficiencyRouteRouteWithChildren
  '/_authenticated/dashboard/locating': typeof AuthenticatedDashboardLocatingRouteRouteWithChildren
  '/_authenticated/dashboard/quality': typeof AuthenticatedDashboardQualityRouteRouteWithChildren
  '/_authenticated/dashboard/roi': typeof AuthenticatedDashboardRoiRouteRouteWithChildren
  '/_authenticated/guidedSetups/$': typeof AuthenticatedGuidedSetupsSplatRoute
  '/_authenticated/requests/{-$requestId}': typeof AuthenticatedRequestsChar123RequestIdChar125Route
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/timesheets/': typeof AuthenticatedTimesheetsIndexRoute
  '/_authenticated/dashboard/activity/$canvasId': typeof AuthenticatedDashboardActivityCanvasIdRoute
  '/_authenticated/dashboard/efficiency/$canvasId': typeof AuthenticatedDashboardEfficiencyCanvasIdRoute
  '/_authenticated/dashboard/locating/$canvasId': typeof AuthenticatedDashboardLocatingCanvasIdRoute
  '/_authenticated/dashboard/quality/$canvasId': typeof AuthenticatedDashboardQualityCanvasIdRoute
  '/_authenticated/dashboard/roi/$canvasId': typeof AuthenticatedDashboardRoiCanvasIdRoute
  '/_authenticated/timesheets/employees/$empId': typeof AuthenticatedTimesheetsEmployeesEmpIdRoute
  '/_authenticated/dashboard/activity/': typeof AuthenticatedDashboardActivityIndexRoute
  '/_authenticated/dashboard/efficiency/': typeof AuthenticatedDashboardEfficiencyIndexRoute
  '/_authenticated/dashboard/locating/': typeof AuthenticatedDashboardLocatingIndexRoute
  '/_authenticated/dashboard/quality/': typeof AuthenticatedDashboardQualityIndexRoute
  '/_authenticated/dashboard/roi/': typeof AuthenticatedDashboardRoiIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/timesheets'
    | '/__e2e/external-display'
    | '/$'
    | '/alerts'
    | '/checksheet-data'
    | '/checksheets'
    | '/clockingRecs'
    | '/configuration'
    | '/connectors'
    | '/customerHealth'
    | '/deviceGroups'
    | '/devices'
    | '/devicesAdmin'
    | '/documentManager'
    | '/employeeGroups'
    | '/employees'
    | '/entities'
    | '/entityAdmin'
    | '/entitySetup'
    | '/externalDisplayLayouts'
    | '/flows'
    | '/fulfillmentAdmin'
    | '/functionalTesting'
    | '/guidedSetups'
    | '/indirects'
    | '/instructions'
    | '/jobs'
    | '/laborOutcomePrediction'
    | '/laborRecs'
    | '/locationAdmin'
    | '/locationManagement'
    | '/machineReasonCategories'
    | '/machineReasons'
    | '/machineRecs'
    | '/notifications'
    | '/optionsRegistry'
    | '/organizationAdmin'
    | '/organizations'
    | '/parts'
    | '/profile'
    | '/programs'
    | '/reasons'
    | '/reports'
    | '/requestTypes'
    | '/resourceAdmin'
    | '/resources'
    | '/ruleSets'
    | '/scheduledTasks'
    | '/schedules'
    | '/scopeFilters'
    | '/security'
    | '/shifts'
    | '/tagAssociationTypes'
    | '/tags'
    | '/trainingAdmin'
    | '/workQueue'
    | '/display/$deviceId'
    | '/login/createPassword'
    | '/login/forgotPassword'
    | '/login/resetPassword'
    | '/display/'
    | '/login/'
    | '/dashboard/activity'
    | '/dashboard/efficiency'
    | '/dashboard/locating'
    | '/dashboard/quality'
    | '/dashboard/roi'
    | '/guidedSetups/$'
    | '/requests/{-$requestId}'
    | '/dashboard/'
    | '/timesheets/'
    | '/dashboard/activity/$canvasId'
    | '/dashboard/efficiency/$canvasId'
    | '/dashboard/locating/$canvasId'
    | '/dashboard/quality/$canvasId'
    | '/dashboard/roi/$canvasId'
    | '/timesheets/employees/$empId'
    | '/dashboard/activity/'
    | '/dashboard/efficiency/'
    | '/dashboard/locating/'
    | '/dashboard/quality/'
    | '/dashboard/roi/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/__e2e/external-display'
    | '/$'
    | '/alerts'
    | '/checksheet-data'
    | '/checksheets'
    | '/clockingRecs'
    | '/configuration'
    | '/connectors'
    | '/customerHealth'
    | '/deviceGroups'
    | '/devices'
    | '/devicesAdmin'
    | '/documentManager'
    | '/employeeGroups'
    | '/employees'
    | '/entities'
    | '/entityAdmin'
    | '/entitySetup'
    | '/externalDisplayLayouts'
    | '/flows'
    | '/fulfillmentAdmin'
    | '/functionalTesting'
    | '/guidedSetups'
    | '/indirects'
    | '/instructions'
    | '/jobs'
    | '/laborOutcomePrediction'
    | '/laborRecs'
    | '/locationAdmin'
    | '/locationManagement'
    | '/machineReasonCategories'
    | '/machineReasons'
    | '/machineRecs'
    | '/notifications'
    | '/optionsRegistry'
    | '/organizationAdmin'
    | '/organizations'
    | '/parts'
    | '/profile'
    | '/programs'
    | '/reasons'
    | '/reports'
    | '/requestTypes'
    | '/resourceAdmin'
    | '/resources'
    | '/ruleSets'
    | '/scheduledTasks'
    | '/schedules'
    | '/scopeFilters'
    | '/security'
    | '/shifts'
    | '/tagAssociationTypes'
    | '/tags'
    | '/trainingAdmin'
    | '/workQueue'
    | '/display/$deviceId'
    | '/login/createPassword'
    | '/login/forgotPassword'
    | '/login/resetPassword'
    | '/'
    | '/display'
    | '/login'
    | '/guidedSetups/$'
    | '/requests/{-$requestId}'
    | '/dashboard'
    | '/timesheets'
    | '/dashboard/activity/$canvasId'
    | '/dashboard/efficiency/$canvasId'
    | '/dashboard/locating/$canvasId'
    | '/dashboard/quality/$canvasId'
    | '/dashboard/roi/$canvasId'
    | '/timesheets/employees/$empId'
    | '/dashboard/activity'
    | '/dashboard/efficiency'
    | '/dashboard/locating'
    | '/dashboard/quality'
    | '/dashboard/roi'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/dashboard'
    | '/_authenticated/timesheets'
    | '/__e2e/external-display'
    | '/_authenticated/$'
    | '/_authenticated/alerts'
    | '/_authenticated/checksheet-data'
    | '/_authenticated/checksheets'
    | '/_authenticated/clockingRecs'
    | '/_authenticated/configuration'
    | '/_authenticated/connectors'
    | '/_authenticated/customerHealth'
    | '/_authenticated/deviceGroups'
    | '/_authenticated/devices'
    | '/_authenticated/devicesAdmin'
    | '/_authenticated/documentManager'
    | '/_authenticated/employeeGroups'
    | '/_authenticated/employees'
    | '/_authenticated/entities'
    | '/_authenticated/entityAdmin'
    | '/_authenticated/entitySetup'
    | '/_authenticated/externalDisplayLayouts'
    | '/_authenticated/flows'
    | '/_authenticated/fulfillmentAdmin'
    | '/_authenticated/functionalTesting'
    | '/_authenticated/guidedSetups'
    | '/_authenticated/indirects'
    | '/_authenticated/instructions'
    | '/_authenticated/jobs'
    | '/_authenticated/laborOutcomePrediction'
    | '/_authenticated/laborRecs'
    | '/_authenticated/locationAdmin'
    | '/_authenticated/locationManagement'
    | '/_authenticated/machineReasonCategories'
    | '/_authenticated/machineReasons'
    | '/_authenticated/machineRecs'
    | '/_authenticated/notifications'
    | '/_authenticated/optionsRegistry'
    | '/_authenticated/organizationAdmin'
    | '/_authenticated/organizations'
    | '/_authenticated/parts'
    | '/_authenticated/profile'
    | '/_authenticated/programs'
    | '/_authenticated/reasons'
    | '/_authenticated/reports'
    | '/_authenticated/requestTypes'
    | '/_authenticated/resourceAdmin'
    | '/_authenticated/resources'
    | '/_authenticated/ruleSets'
    | '/_authenticated/scheduledTasks'
    | '/_authenticated/schedules'
    | '/_authenticated/scopeFilters'
    | '/_authenticated/security'
    | '/_authenticated/shifts'
    | '/_authenticated/tagAssociationTypes'
    | '/_authenticated/tags'
    | '/_authenticated/trainingAdmin'
    | '/_authenticated/workQueue'
    | '/display/$deviceId'
    | '/login/createPassword'
    | '/login/forgotPassword'
    | '/login/resetPassword'
    | '/_authenticated/'
    | '/display/'
    | '/login/'
    | '/_authenticated/dashboard/activity'
    | '/_authenticated/dashboard/efficiency'
    | '/_authenticated/dashboard/locating'
    | '/_authenticated/dashboard/quality'
    | '/_authenticated/dashboard/roi'
    | '/_authenticated/guidedSetups/$'
    | '/_authenticated/requests/{-$requestId}'
    | '/_authenticated/dashboard/'
    | '/_authenticated/timesheets/'
    | '/_authenticated/dashboard/activity/$canvasId'
    | '/_authenticated/dashboard/efficiency/$canvasId'
    | '/_authenticated/dashboard/locating/$canvasId'
    | '/_authenticated/dashboard/quality/$canvasId'
    | '/_authenticated/dashboard/roi/$canvasId'
    | '/_authenticated/timesheets/employees/$empId'
    | '/_authenticated/dashboard/activity/'
    | '/_authenticated/dashboard/efficiency/'
    | '/_authenticated/dashboard/locating/'
    | '/_authenticated/dashboard/quality/'
    | '/_authenticated/dashboard/roi/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
  Char91__e2eChar93ExternalDisplayRoute: typeof Char91__e2eChar93ExternalDisplayRoute
  DisplayDeviceIdRoute: typeof DisplayDeviceIdRoute
  DisplayIndexRoute: typeof DisplayIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__e2e/external-display': {
      id: '/__e2e/external-display'
      path: '/__e2e/external-display'
      fullPath: '/__e2e/external-display'
      preLoaderRoute: typeof Char91__e2eChar93ExternalDisplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/alerts': {
      id: '/_authenticated/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthenticatedAlertsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/checksheet-data': {
      id: '/_authenticated/checksheet-data'
      path: '/checksheet-data'
      fullPath: '/checksheet-data'
      preLoaderRoute: typeof AuthenticatedChecksheetDataRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/checksheets': {
      id: '/_authenticated/checksheets'
      path: '/checksheets'
      fullPath: '/checksheets'
      preLoaderRoute: typeof AuthenticatedChecksheetsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/clockingRecs': {
      id: '/_authenticated/clockingRecs'
      path: '/clockingRecs'
      fullPath: '/clockingRecs'
      preLoaderRoute: typeof AuthenticatedClockingRecsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/configuration': {
      id: '/_authenticated/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof AuthenticatedConfigurationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/connectors': {
      id: '/_authenticated/connectors'
      path: '/connectors'
      fullPath: '/connectors'
      preLoaderRoute: typeof AuthenticatedConnectorsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customerHealth': {
      id: '/_authenticated/customerHealth'
      path: '/customerHealth'
      fullPath: '/customerHealth'
      preLoaderRoute: typeof AuthenticatedCustomerHealthRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deviceGroups': {
      id: '/_authenticated/deviceGroups'
      path: '/deviceGroups'
      fullPath: '/deviceGroups'
      preLoaderRoute: typeof AuthenticatedDeviceGroupsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices': {
      id: '/_authenticated/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthenticatedDevicesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devicesAdmin': {
      id: '/_authenticated/devicesAdmin'
      path: '/devicesAdmin'
      fullPath: '/devicesAdmin'
      preLoaderRoute: typeof AuthenticatedDevicesAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documentManager': {
      id: '/_authenticated/documentManager'
      path: '/documentManager'
      fullPath: '/documentManager'
      preLoaderRoute: typeof AuthenticatedDocumentManagerRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/employeeGroups': {
      id: '/_authenticated/employeeGroups'
      path: '/employeeGroups'
      fullPath: '/employeeGroups'
      preLoaderRoute: typeof AuthenticatedEmployeeGroupsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/employees': {
      id: '/_authenticated/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/entities': {
      id: '/_authenticated/entities'
      path: '/entities'
      fullPath: '/entities'
      preLoaderRoute: typeof AuthenticatedEntitiesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/entityAdmin': {
      id: '/_authenticated/entityAdmin'
      path: '/entityAdmin'
      fullPath: '/entityAdmin'
      preLoaderRoute: typeof AuthenticatedEntityAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/entitySetup': {
      id: '/_authenticated/entitySetup'
      path: '/entitySetup'
      fullPath: '/entitySetup'
      preLoaderRoute: typeof AuthenticatedEntitySetupRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/externalDisplayLayouts': {
      id: '/_authenticated/externalDisplayLayouts'
      path: '/externalDisplayLayouts'
      fullPath: '/externalDisplayLayouts'
      preLoaderRoute: typeof AuthenticatedExternalDisplayLayoutsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/flows': {
      id: '/_authenticated/flows'
      path: '/flows'
      fullPath: '/flows'
      preLoaderRoute: typeof AuthenticatedFlowsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fulfillmentAdmin': {
      id: '/_authenticated/fulfillmentAdmin'
      path: '/fulfillmentAdmin'
      fullPath: '/fulfillmentAdmin'
      preLoaderRoute: typeof AuthenticatedFulfillmentAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/functionalTesting': {
      id: '/_authenticated/functionalTesting'
      path: '/functionalTesting'
      fullPath: '/functionalTesting'
      preLoaderRoute: typeof AuthenticatedFunctionalTestingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/guidedSetups': {
      id: '/_authenticated/guidedSetups'
      path: '/guidedSetups'
      fullPath: '/guidedSetups'
      preLoaderRoute: typeof AuthenticatedGuidedSetupsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/indirects': {
      id: '/_authenticated/indirects'
      path: '/indirects'
      fullPath: '/indirects'
      preLoaderRoute: typeof AuthenticatedIndirectsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instructions': {
      id: '/_authenticated/instructions'
      path: '/instructions'
      fullPath: '/instructions'
      preLoaderRoute: typeof AuthenticatedInstructionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs': {
      id: '/_authenticated/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/laborOutcomePrediction': {
      id: '/_authenticated/laborOutcomePrediction'
      path: '/laborOutcomePrediction'
      fullPath: '/laborOutcomePrediction'
      preLoaderRoute: typeof AuthenticatedLaborOutcomePredictionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/laborRecs': {
      id: '/_authenticated/laborRecs'
      path: '/laborRecs'
      fullPath: '/laborRecs'
      preLoaderRoute: typeof AuthenticatedLaborRecsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/locationAdmin': {
      id: '/_authenticated/locationAdmin'
      path: '/locationAdmin'
      fullPath: '/locationAdmin'
      preLoaderRoute: typeof AuthenticatedLocationAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/locationManagement': {
      id: '/_authenticated/locationManagement'
      path: '/locationManagement'
      fullPath: '/locationManagement'
      preLoaderRoute: typeof AuthenticatedLocationManagementRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/machineReasonCategories': {
      id: '/_authenticated/machineReasonCategories'
      path: '/machineReasonCategories'
      fullPath: '/machineReasonCategories'
      preLoaderRoute: typeof AuthenticatedMachineReasonCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/machineReasons': {
      id: '/_authenticated/machineReasons'
      path: '/machineReasons'
      fullPath: '/machineReasons'
      preLoaderRoute: typeof AuthenticatedMachineReasonsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/machineRecs': {
      id: '/_authenticated/machineRecs'
      path: '/machineRecs'
      fullPath: '/machineRecs'
      preLoaderRoute: typeof AuthenticatedMachineRecsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/optionsRegistry': {
      id: '/_authenticated/optionsRegistry'
      path: '/optionsRegistry'
      fullPath: '/optionsRegistry'
      preLoaderRoute: typeof AuthenticatedOptionsRegistryRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizationAdmin': {
      id: '/_authenticated/organizationAdmin'
      path: '/organizationAdmin'
      fullPath: '/organizationAdmin'
      preLoaderRoute: typeof AuthenticatedOrganizationAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizations': {
      id: '/_authenticated/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts': {
      id: '/_authenticated/parts'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof AuthenticatedPartsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/programs': {
      id: '/_authenticated/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof AuthenticatedProgramsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reasons': {
      id: '/_authenticated/reasons'
      path: '/reasons'
      fullPath: '/reasons'
      preLoaderRoute: typeof AuthenticatedReasonsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/requestTypes': {
      id: '/_authenticated/requestTypes'
      path: '/requestTypes'
      fullPath: '/requestTypes'
      preLoaderRoute: typeof AuthenticatedRequestTypesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/resourceAdmin': {
      id: '/_authenticated/resourceAdmin'
      path: '/resourceAdmin'
      fullPath: '/resourceAdmin'
      preLoaderRoute: typeof AuthenticatedResourceAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/resources': {
      id: '/_authenticated/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthenticatedResourcesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ruleSets': {
      id: '/_authenticated/ruleSets'
      path: '/ruleSets'
      fullPath: '/ruleSets'
      preLoaderRoute: typeof AuthenticatedRuleSetsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/scheduledTasks': {
      id: '/_authenticated/scheduledTasks'
      path: '/scheduledTasks'
      fullPath: '/scheduledTasks'
      preLoaderRoute: typeof AuthenticatedScheduledTasksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/schedules': {
      id: '/_authenticated/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof AuthenticatedSchedulesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/scopeFilters': {
      id: '/_authenticated/scopeFilters'
      path: '/scopeFilters'
      fullPath: '/scopeFilters'
      preLoaderRoute: typeof AuthenticatedScopeFiltersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/security': {
      id: '/_authenticated/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AuthenticatedSecurityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/shifts': {
      id: '/_authenticated/shifts'
      path: '/shifts'
      fullPath: '/shifts'
      preLoaderRoute: typeof AuthenticatedShiftsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tagAssociationTypes': {
      id: '/_authenticated/tagAssociationTypes'
      path: '/tagAssociationTypes'
      fullPath: '/tagAssociationTypes'
      preLoaderRoute: typeof AuthenticatedTagAssociationTypesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tags': {
      id: '/_authenticated/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof AuthenticatedTagsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/timesheets': {
      id: '/_authenticated/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AuthenticatedTimesheetsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainingAdmin': {
      id: '/_authenticated/trainingAdmin'
      path: '/trainingAdmin'
      fullPath: '/trainingAdmin'
      preLoaderRoute: typeof AuthenticatedTrainingAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workQueue': {
      id: '/_authenticated/workQueue'
      path: '/workQueue'
      fullPath: '/workQueue'
      preLoaderRoute: typeof AuthenticatedWorkQueueRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/display/': {
      id: '/display/'
      path: '/display'
      fullPath: '/display/'
      preLoaderRoute: typeof DisplayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display/$deviceId': {
      id: '/display/$deviceId'
      path: '/display/$deviceId'
      fullPath: '/display/$deviceId'
      preLoaderRoute: typeof DisplayDeviceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/createPassword': {
      id: '/login/createPassword'
      path: '/createPassword'
      fullPath: '/login/createPassword'
      preLoaderRoute: typeof LoginCreatePasswordRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/forgotPassword': {
      id: '/login/forgotPassword'
      path: '/forgotPassword'
      fullPath: '/login/forgotPassword'
      preLoaderRoute: typeof LoginForgotPasswordRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/resetPassword': {
      id: '/login/resetPassword'
      path: '/resetPassword'
      fullPath: '/login/resetPassword'
      preLoaderRoute: typeof LoginResetPasswordRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/activity': {
      id: '/_authenticated/dashboard/activity'
      path: '/activity'
      fullPath: '/dashboard/activity'
      preLoaderRoute: typeof AuthenticatedDashboardActivityRouteRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/efficiency': {
      id: '/_authenticated/dashboard/efficiency'
      path: '/efficiency'
      fullPath: '/dashboard/efficiency'
      preLoaderRoute: typeof AuthenticatedDashboardEfficiencyRouteRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/locating': {
      id: '/_authenticated/dashboard/locating'
      path: '/locating'
      fullPath: '/dashboard/locating'
      preLoaderRoute: typeof AuthenticatedDashboardLocatingRouteRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/quality': {
      id: '/_authenticated/dashboard/quality'
      path: '/quality'
      fullPath: '/dashboard/quality'
      preLoaderRoute: typeof AuthenticatedDashboardQualityRouteRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/roi': {
      id: '/_authenticated/dashboard/roi'
      path: '/roi'
      fullPath: '/dashboard/roi'
      preLoaderRoute: typeof AuthenticatedDashboardRoiRouteRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/guidedSetups/$': {
      id: '/_authenticated/guidedSetups/$'
      path: '/$'
      fullPath: '/guidedSetups/$'
      preLoaderRoute: typeof AuthenticatedGuidedSetupsSplatRouteImport
      parentRoute: typeof AuthenticatedGuidedSetupsRoute
    }
    '/_authenticated/requests/{-$requestId}': {
      id: '/_authenticated/requests/{-$requestId}'
      path: '/requests/{-$requestId}'
      fullPath: '/requests/{-$requestId}'
      preLoaderRoute: typeof AuthenticatedRequestsChar123RequestIdChar125RouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/timesheets/': {
      id: '/_authenticated/timesheets/'
      path: '/'
      fullPath: '/timesheets/'
      preLoaderRoute: typeof AuthenticatedTimesheetsIndexRouteImport
      parentRoute: typeof AuthenticatedTimesheetsRouteRoute
    }
    '/_authenticated/dashboard/activity/': {
      id: '/_authenticated/dashboard/activity/'
      path: '/'
      fullPath: '/dashboard/activity/'
      preLoaderRoute: typeof AuthenticatedDashboardActivityIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardActivityRouteRoute
    }
    '/_authenticated/dashboard/activity/$canvasId': {
      id: '/_authenticated/dashboard/activity/$canvasId'
      path: '/$canvasId'
      fullPath: '/dashboard/activity/$canvasId'
      preLoaderRoute: typeof AuthenticatedDashboardActivityCanvasIdRouteImport
      parentRoute: typeof AuthenticatedDashboardActivityRouteRoute
    }
    '/_authenticated/dashboard/efficiency/': {
      id: '/_authenticated/dashboard/efficiency/'
      path: '/'
      fullPath: '/dashboard/efficiency/'
      preLoaderRoute: typeof AuthenticatedDashboardEfficiencyIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardEfficiencyRouteRoute
    }
    '/_authenticated/dashboard/efficiency/$canvasId': {
      id: '/_authenticated/dashboard/efficiency/$canvasId'
      path: '/$canvasId'
      fullPath: '/dashboard/efficiency/$canvasId'
      preLoaderRoute: typeof AuthenticatedDashboardEfficiencyCanvasIdRouteImport
      parentRoute: typeof AuthenticatedDashboardEfficiencyRouteRoute
    }
    '/_authenticated/dashboard/locating/': {
      id: '/_authenticated/dashboard/locating/'
      path: '/'
      fullPath: '/dashboard/locating/'
      preLoaderRoute: typeof AuthenticatedDashboardLocatingIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardLocatingRouteRoute
    }
    '/_authenticated/dashboard/locating/$canvasId': {
      id: '/_authenticated/dashboard/locating/$canvasId'
      path: '/$canvasId'
      fullPath: '/dashboard/locating/$canvasId'
      preLoaderRoute: typeof AuthenticatedDashboardLocatingCanvasIdRouteImport
      parentRoute: typeof AuthenticatedDashboardLocatingRouteRoute
    }
    '/_authenticated/dashboard/quality/': {
      id: '/_authenticated/dashboard/quality/'
      path: '/'
      fullPath: '/dashboard/quality/'
      preLoaderRoute: typeof AuthenticatedDashboardQualityIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardQualityRouteRoute
    }
    '/_authenticated/dashboard/quality/$canvasId': {
      id: '/_authenticated/dashboard/quality/$canvasId'
      path: '/$canvasId'
      fullPath: '/dashboard/quality/$canvasId'
      preLoaderRoute: typeof AuthenticatedDashboardQualityCanvasIdRouteImport
      parentRoute: typeof AuthenticatedDashboardQualityRouteRoute
    }
    '/_authenticated/dashboard/roi/': {
      id: '/_authenticated/dashboard/roi/'
      path: '/'
      fullPath: '/dashboard/roi/'
      preLoaderRoute: typeof AuthenticatedDashboardRoiIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoiRouteRoute
    }
    '/_authenticated/dashboard/roi/$canvasId': {
      id: '/_authenticated/dashboard/roi/$canvasId'
      path: '/$canvasId'
      fullPath: '/dashboard/roi/$canvasId'
      preLoaderRoute: typeof AuthenticatedDashboardRoiCanvasIdRouteImport
      parentRoute: typeof AuthenticatedDashboardRoiRouteRoute
    }
    '/_authenticated/timesheets/employees/$empId': {
      id: '/_authenticated/timesheets/employees/$empId'
      path: '/employees/$empId'
      fullPath: '/timesheets/employees/$empId'
      preLoaderRoute: typeof AuthenticatedTimesheetsEmployeesEmpIdRouteImport
      parentRoute: typeof AuthenticatedTimesheetsRouteRoute
    }
  }
}

interface AuthenticatedDashboardActivityRouteRouteChildren {
  AuthenticatedDashboardActivityCanvasIdRoute: typeof AuthenticatedDashboardActivityCanvasIdRoute
  AuthenticatedDashboardActivityIndexRoute: typeof AuthenticatedDashboardActivityIndexRoute
}

const AuthenticatedDashboardActivityRouteRouteChildren: AuthenticatedDashboardActivityRouteRouteChildren =
  {
    AuthenticatedDashboardActivityCanvasIdRoute:
      AuthenticatedDashboardActivityCanvasIdRoute,
    AuthenticatedDashboardActivityIndexRoute:
      AuthenticatedDashboardActivityIndexRoute,
  }

const AuthenticatedDashboardActivityRouteRouteWithChildren =
  AuthenticatedDashboardActivityRouteRoute._addFileChildren(
    AuthenticatedDashboardActivityRouteRouteChildren,
  )

interface AuthenticatedDashboardEfficiencyRouteRouteChildren {
  AuthenticatedDashboardEfficiencyCanvasIdRoute: typeof AuthenticatedDashboardEfficiencyCanvasIdRoute
  AuthenticatedDashboardEfficiencyIndexRoute: typeof AuthenticatedDashboardEfficiencyIndexRoute
}

const AuthenticatedDashboardEfficiencyRouteRouteChildren: AuthenticatedDashboardEfficiencyRouteRouteChildren =
  {
    AuthenticatedDashboardEfficiencyCanvasIdRoute:
      AuthenticatedDashboardEfficiencyCanvasIdRoute,
    AuthenticatedDashboardEfficiencyIndexRoute:
      AuthenticatedDashboardEfficiencyIndexRoute,
  }

const AuthenticatedDashboardEfficiencyRouteRouteWithChildren =
  AuthenticatedDashboardEfficiencyRouteRoute._addFileChildren(
    AuthenticatedDashboardEfficiencyRouteRouteChildren,
  )

interface AuthenticatedDashboardLocatingRouteRouteChildren {
  AuthenticatedDashboardLocatingCanvasIdRoute: typeof AuthenticatedDashboardLocatingCanvasIdRoute
  AuthenticatedDashboardLocatingIndexRoute: typeof AuthenticatedDashboardLocatingIndexRoute
}

const AuthenticatedDashboardLocatingRouteRouteChildren: AuthenticatedDashboardLocatingRouteRouteChildren =
  {
    AuthenticatedDashboardLocatingCanvasIdRoute:
      AuthenticatedDashboardLocatingCanvasIdRoute,
    AuthenticatedDashboardLocatingIndexRoute:
      AuthenticatedDashboardLocatingIndexRoute,
  }

const AuthenticatedDashboardLocatingRouteRouteWithChildren =
  AuthenticatedDashboardLocatingRouteRoute._addFileChildren(
    AuthenticatedDashboardLocatingRouteRouteChildren,
  )

interface AuthenticatedDashboardQualityRouteRouteChildren {
  AuthenticatedDashboardQualityCanvasIdRoute: typeof AuthenticatedDashboardQualityCanvasIdRoute
  AuthenticatedDashboardQualityIndexRoute: typeof AuthenticatedDashboardQualityIndexRoute
}

const AuthenticatedDashboardQualityRouteRouteChildren: AuthenticatedDashboardQualityRouteRouteChildren =
  {
    AuthenticatedDashboardQualityCanvasIdRoute:
      AuthenticatedDashboardQualityCanvasIdRoute,
    AuthenticatedDashboardQualityIndexRoute:
      AuthenticatedDashboardQualityIndexRoute,
  }

const AuthenticatedDashboardQualityRouteRouteWithChildren =
  AuthenticatedDashboardQualityRouteRoute._addFileChildren(
    AuthenticatedDashboardQualityRouteRouteChildren,
  )

interface AuthenticatedDashboardRoiRouteRouteChildren {
  AuthenticatedDashboardRoiCanvasIdRoute: typeof AuthenticatedDashboardRoiCanvasIdRoute
  AuthenticatedDashboardRoiIndexRoute: typeof AuthenticatedDashboardRoiIndexRoute
}

const AuthenticatedDashboardRoiRouteRouteChildren: AuthenticatedDashboardRoiRouteRouteChildren =
  {
    AuthenticatedDashboardRoiCanvasIdRoute:
      AuthenticatedDashboardRoiCanvasIdRoute,
    AuthenticatedDashboardRoiIndexRoute: AuthenticatedDashboardRoiIndexRoute,
  }

const AuthenticatedDashboardRoiRouteRouteWithChildren =
  AuthenticatedDashboardRoiRouteRoute._addFileChildren(
    AuthenticatedDashboardRoiRouteRouteChildren,
  )

interface AuthenticatedDashboardRouteRouteChildren {
  AuthenticatedDashboardActivityRouteRoute: typeof AuthenticatedDashboardActivityRouteRouteWithChildren
  AuthenticatedDashboardEfficiencyRouteRoute: typeof AuthenticatedDashboardEfficiencyRouteRouteWithChildren
  AuthenticatedDashboardLocatingRouteRoute: typeof AuthenticatedDashboardLocatingRouteRouteWithChildren
  AuthenticatedDashboardQualityRouteRoute: typeof AuthenticatedDashboardQualityRouteRouteWithChildren
  AuthenticatedDashboardRoiRouteRoute: typeof AuthenticatedDashboardRoiRouteRouteWithChildren
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
}

const AuthenticatedDashboardRouteRouteChildren: AuthenticatedDashboardRouteRouteChildren =
  {
    AuthenticatedDashboardActivityRouteRoute:
      AuthenticatedDashboardActivityRouteRouteWithChildren,
    AuthenticatedDashboardEfficiencyRouteRoute:
      AuthenticatedDashboardEfficiencyRouteRouteWithChildren,
    AuthenticatedDashboardLocatingRouteRoute:
      AuthenticatedDashboardLocatingRouteRouteWithChildren,
    AuthenticatedDashboardQualityRouteRoute:
      AuthenticatedDashboardQualityRouteRouteWithChildren,
    AuthenticatedDashboardRoiRouteRoute:
      AuthenticatedDashboardRoiRouteRouteWithChildren,
    AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  }

const AuthenticatedDashboardRouteRouteWithChildren =
  AuthenticatedDashboardRouteRoute._addFileChildren(
    AuthenticatedDashboardRouteRouteChildren,
  )

interface AuthenticatedTimesheetsRouteRouteChildren {
  AuthenticatedTimesheetsIndexRoute: typeof AuthenticatedTimesheetsIndexRoute
  AuthenticatedTimesheetsEmployeesEmpIdRoute: typeof AuthenticatedTimesheetsEmployeesEmpIdRoute
}

const AuthenticatedTimesheetsRouteRouteChildren: AuthenticatedTimesheetsRouteRouteChildren =
  {
    AuthenticatedTimesheetsIndexRoute: AuthenticatedTimesheetsIndexRoute,
    AuthenticatedTimesheetsEmployeesEmpIdRoute:
      AuthenticatedTimesheetsEmployeesEmpIdRoute,
  }

const AuthenticatedTimesheetsRouteRouteWithChildren =
  AuthenticatedTimesheetsRouteRoute._addFileChildren(
    AuthenticatedTimesheetsRouteRouteChildren,
  )

interface AuthenticatedGuidedSetupsRouteChildren {
  AuthenticatedGuidedSetupsSplatRoute: typeof AuthenticatedGuidedSetupsSplatRoute
}

const AuthenticatedGuidedSetupsRouteChildren: AuthenticatedGuidedSetupsRouteChildren =
  {
    AuthenticatedGuidedSetupsSplatRoute: AuthenticatedGuidedSetupsSplatRoute,
  }

const AuthenticatedGuidedSetupsRouteWithChildren =
  AuthenticatedGuidedSetupsRoute._addFileChildren(
    AuthenticatedGuidedSetupsRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedDashboardRouteRoute: typeof AuthenticatedDashboardRouteRouteWithChildren
  AuthenticatedTimesheetsRouteRoute: typeof AuthenticatedTimesheetsRouteRouteWithChildren
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedAlertsRoute: typeof AuthenticatedAlertsRoute
  AuthenticatedChecksheetDataRoute: typeof AuthenticatedChecksheetDataRoute
  AuthenticatedChecksheetsRoute: typeof AuthenticatedChecksheetsRoute
  AuthenticatedClockingRecsRoute: typeof AuthenticatedClockingRecsRoute
  AuthenticatedConfigurationRoute: typeof AuthenticatedConfigurationRoute
  AuthenticatedConnectorsRoute: typeof AuthenticatedConnectorsRoute
  AuthenticatedCustomerHealthRoute: typeof AuthenticatedCustomerHealthRoute
  AuthenticatedDeviceGroupsRoute: typeof AuthenticatedDeviceGroupsRoute
  AuthenticatedDevicesRoute: typeof AuthenticatedDevicesRoute
  AuthenticatedDevicesAdminRoute: typeof AuthenticatedDevicesAdminRoute
  AuthenticatedDocumentManagerRoute: typeof AuthenticatedDocumentManagerRoute
  AuthenticatedEmployeeGroupsRoute: typeof AuthenticatedEmployeeGroupsRoute
  AuthenticatedEmployeesRoute: typeof AuthenticatedEmployeesRoute
  AuthenticatedEntitiesRoute: typeof AuthenticatedEntitiesRoute
  AuthenticatedEntityAdminRoute: typeof AuthenticatedEntityAdminRoute
  AuthenticatedEntitySetupRoute: typeof AuthenticatedEntitySetupRoute
  AuthenticatedExternalDisplayLayoutsRoute: typeof AuthenticatedExternalDisplayLayoutsRoute
  AuthenticatedFlowsRoute: typeof AuthenticatedFlowsRoute
  AuthenticatedFulfillmentAdminRoute: typeof AuthenticatedFulfillmentAdminRoute
  AuthenticatedFunctionalTestingRoute: typeof AuthenticatedFunctionalTestingRoute
  AuthenticatedGuidedSetupsRoute: typeof AuthenticatedGuidedSetupsRouteWithChildren
  AuthenticatedIndirectsRoute: typeof AuthenticatedIndirectsRoute
  AuthenticatedInstructionsRoute: typeof AuthenticatedInstructionsRoute
  AuthenticatedJobsRoute: typeof AuthenticatedJobsRoute
  AuthenticatedLaborOutcomePredictionRoute: typeof AuthenticatedLaborOutcomePredictionRoute
  AuthenticatedLaborRecsRoute: typeof AuthenticatedLaborRecsRoute
  AuthenticatedLocationAdminRoute: typeof AuthenticatedLocationAdminRoute
  AuthenticatedLocationManagementRoute: typeof AuthenticatedLocationManagementRoute
  AuthenticatedMachineReasonCategoriesRoute: typeof AuthenticatedMachineReasonCategoriesRoute
  AuthenticatedMachineReasonsRoute: typeof AuthenticatedMachineReasonsRoute
  AuthenticatedMachineRecsRoute: typeof AuthenticatedMachineRecsRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedOptionsRegistryRoute: typeof AuthenticatedOptionsRegistryRoute
  AuthenticatedOrganizationAdminRoute: typeof AuthenticatedOrganizationAdminRoute
  AuthenticatedOrganizationsRoute: typeof AuthenticatedOrganizationsRoute
  AuthenticatedPartsRoute: typeof AuthenticatedPartsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedProgramsRoute: typeof AuthenticatedProgramsRoute
  AuthenticatedReasonsRoute: typeof AuthenticatedReasonsRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedRequestTypesRoute: typeof AuthenticatedRequestTypesRoute
  AuthenticatedResourceAdminRoute: typeof AuthenticatedResourceAdminRoute
  AuthenticatedResourcesRoute: typeof AuthenticatedResourcesRoute
  AuthenticatedRuleSetsRoute: typeof AuthenticatedRuleSetsRoute
  AuthenticatedScheduledTasksRoute: typeof AuthenticatedScheduledTasksRoute
  AuthenticatedSchedulesRoute: typeof AuthenticatedSchedulesRoute
  AuthenticatedScopeFiltersRoute: typeof AuthenticatedScopeFiltersRoute
  AuthenticatedSecurityRoute: typeof AuthenticatedSecurityRoute
  AuthenticatedShiftsRoute: typeof AuthenticatedShiftsRoute
  AuthenticatedTagAssociationTypesRoute: typeof AuthenticatedTagAssociationTypesRoute
  AuthenticatedTagsRoute: typeof AuthenticatedTagsRoute
  AuthenticatedTrainingAdminRoute: typeof AuthenticatedTrainingAdminRoute
  AuthenticatedWorkQueueRoute: typeof AuthenticatedWorkQueueRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedRequestsChar123RequestIdChar125Route: typeof AuthenticatedRequestsChar123RequestIdChar125Route
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRouteRoute:
    AuthenticatedDashboardRouteRouteWithChildren,
  AuthenticatedTimesheetsRouteRoute:
    AuthenticatedTimesheetsRouteRouteWithChildren,
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedAlertsRoute: AuthenticatedAlertsRoute,
  AuthenticatedChecksheetDataRoute: AuthenticatedChecksheetDataRoute,
  AuthenticatedChecksheetsRoute: AuthenticatedChecksheetsRoute,
  AuthenticatedClockingRecsRoute: AuthenticatedClockingRecsRoute,
  AuthenticatedConfigurationRoute: AuthenticatedConfigurationRoute,
  AuthenticatedConnectorsRoute: AuthenticatedConnectorsRoute,
  AuthenticatedCustomerHealthRoute: AuthenticatedCustomerHealthRoute,
  AuthenticatedDeviceGroupsRoute: AuthenticatedDeviceGroupsRoute,
  AuthenticatedDevicesRoute: AuthenticatedDevicesRoute,
  AuthenticatedDevicesAdminRoute: AuthenticatedDevicesAdminRoute,
  AuthenticatedDocumentManagerRoute: AuthenticatedDocumentManagerRoute,
  AuthenticatedEmployeeGroupsRoute: AuthenticatedEmployeeGroupsRoute,
  AuthenticatedEmployeesRoute: AuthenticatedEmployeesRoute,
  AuthenticatedEntitiesRoute: AuthenticatedEntitiesRoute,
  AuthenticatedEntityAdminRoute: AuthenticatedEntityAdminRoute,
  AuthenticatedEntitySetupRoute: AuthenticatedEntitySetupRoute,
  AuthenticatedExternalDisplayLayoutsRoute:
    AuthenticatedExternalDisplayLayoutsRoute,
  AuthenticatedFlowsRoute: AuthenticatedFlowsRoute,
  AuthenticatedFulfillmentAdminRoute: AuthenticatedFulfillmentAdminRoute,
  AuthenticatedFunctionalTestingRoute: AuthenticatedFunctionalTestingRoute,
  AuthenticatedGuidedSetupsRoute: AuthenticatedGuidedSetupsRouteWithChildren,
  AuthenticatedIndirectsRoute: AuthenticatedIndirectsRoute,
  AuthenticatedInstructionsRoute: AuthenticatedInstructionsRoute,
  AuthenticatedJobsRoute: AuthenticatedJobsRoute,
  AuthenticatedLaborOutcomePredictionRoute:
    AuthenticatedLaborOutcomePredictionRoute,
  AuthenticatedLaborRecsRoute: AuthenticatedLaborRecsRoute,
  AuthenticatedLocationAdminRoute: AuthenticatedLocationAdminRoute,
  AuthenticatedLocationManagementRoute: AuthenticatedLocationManagementRoute,
  AuthenticatedMachineReasonCategoriesRoute:
    AuthenticatedMachineReasonCategoriesRoute,
  AuthenticatedMachineReasonsRoute: AuthenticatedMachineReasonsRoute,
  AuthenticatedMachineRecsRoute: AuthenticatedMachineRecsRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedOptionsRegistryRoute: AuthenticatedOptionsRegistryRoute,
  AuthenticatedOrganizationAdminRoute: AuthenticatedOrganizationAdminRoute,
  AuthenticatedOrganizationsRoute: AuthenticatedOrganizationsRoute,
  AuthenticatedPartsRoute: AuthenticatedPartsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedProgramsRoute: AuthenticatedProgramsRoute,
  AuthenticatedReasonsRoute: AuthenticatedReasonsRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedRequestTypesRoute: AuthenticatedRequestTypesRoute,
  AuthenticatedResourceAdminRoute: AuthenticatedResourceAdminRoute,
  AuthenticatedResourcesRoute: AuthenticatedResourcesRoute,
  AuthenticatedRuleSetsRoute: AuthenticatedRuleSetsRoute,
  AuthenticatedScheduledTasksRoute: AuthenticatedScheduledTasksRoute,
  AuthenticatedSchedulesRoute: AuthenticatedSchedulesRoute,
  AuthenticatedScopeFiltersRoute: AuthenticatedScopeFiltersRoute,
  AuthenticatedSecurityRoute: AuthenticatedSecurityRoute,
  AuthenticatedShiftsRoute: AuthenticatedShiftsRoute,
  AuthenticatedTagAssociationTypesRoute: AuthenticatedTagAssociationTypesRoute,
  AuthenticatedTagsRoute: AuthenticatedTagsRoute,
  AuthenticatedTrainingAdminRoute: AuthenticatedTrainingAdminRoute,
  AuthenticatedWorkQueueRoute: AuthenticatedWorkQueueRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedRequestsChar123RequestIdChar125Route:
    AuthenticatedRequestsChar123RequestIdChar125Route,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface LoginRouteRouteChildren {
  LoginCreatePasswordRoute: typeof LoginCreatePasswordRoute
  LoginForgotPasswordRoute: typeof LoginForgotPasswordRoute
  LoginResetPasswordRoute: typeof LoginResetPasswordRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginCreatePasswordRoute: LoginCreatePasswordRoute,
  LoginForgotPasswordRoute: LoginForgotPasswordRoute,
  LoginResetPasswordRoute: LoginResetPasswordRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRouteRoute: LoginRouteRouteWithChildren,
  Char91__e2eChar93ExternalDisplayRoute: Char91__e2eChar93ExternalDisplayRoute,
  DisplayDeviceIdRoute: DisplayDeviceIdRoute,
  DisplayIndexRoute: DisplayIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
